// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\">Forgiveness & Discharge Forms</h1> <p>Find out if you are eligible to have your loan debt reduced or eliminated.</p> ";
// Exports
export default code;